import React from "react";
import Layout from "../../layouts/Layout";
import { SectionTitle , ForgotPass } from "../../components";

const ForgotPassword = () => {
  return (
    <Layout title={"Forgot Password "}>
      <div className="dg__market__data pt--130 pb--80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <SectionTitle title={"Forgot Password"} />
              <ForgotPass/>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPassword;
